import { inject, Injectable } from "@angular/core";
import { ESidenavMenuType } from "./sidenav-menu-type.enum";
import { ESlidenavMenu, ISidenavMenu as ISidenavMenuItem } from '../components/sidenav-menu-item/models';
import { htmlUrls } from "@shared/utils/router-paths";
import { UserStateService } from "@app/state/user-state.service";

@Injectable({
    providedIn: 'root'
})
export class SidenavMenuGenerator {

    userStateService = inject(UserStateService)

    generate(type: ESidenavMenuType): ISidenavMenuItem[] {
        const userId = this.userStateService.userDataSnapshot?.id;
        const userName = this.userStateService.userDataSnapshot?.uniqeName;
        if (type === ESidenavMenuType.MOBILE_FEEDS) {
            return [
                {
                    count: 0,
                    icon: 'library-regular',
                    title: 'کتابخانۀ من',
                    query: {
                        'shelfOwner': this.userStateService.userDataSnapshot?.firstName,
                    },
                    type: ESlidenavMenu.LIBRARY,
                    link: this._linkGenerator(ESlidenavMenu.LIBRARY, userId)
                },
                {
                    count: 0,
                    icon: 'bookmark-regular',
                    title: 'نشان‌شده‌ها',
                    type: ESlidenavMenu.BOOKMARKS,
                    link: this._linkGenerator(ESlidenavMenu.BOOKMARKS, userId)
                },
                {
                    count: 0,
                    icon: 'people-team-regular',
                    title: 'باشگاه‌های کتابخوانی',
                    type: ESlidenavMenu.CLUBS,
                    link: this._linkGenerator(ESlidenavMenu.CLUBS, userId)
                },
                {
                    count: 0,
                    icon: 'ribbon-star-regular',
                    title: 'چالش‌ها',
                    type: ESlidenavMenu.CHALLENGES,
                    link: this._linkGenerator(ESlidenavMenu.CHALLENGES, userId)
                },
                {
                    count: 0,
                    icon: 'book-add-regular',
                    title: 'کتابداری',
                    type: ESlidenavMenu.ADDED_BOOKS,
                    link: this._linkGenerator(ESlidenavMenu.ADDED_BOOKS, userName)
                },
                {
                    count: 0,
                    icon: 'settings-regular',
                    title: 'تنظیمات',
                    type: ESlidenavMenu.SETTING,
                    link: this._linkGenerator(ESlidenavMenu.SETTING, userId)
                },
                {
                    count: 0,
                    icon: 'error-circle-regular1',
                    title: 'راهنمای بهخوان',
                    type: ESlidenavMenu.GUID,
                    link: this._linkGenerator(ESlidenavMenu.GUID, userId)
                },
                {
                    count: 0,
                    icon: 'headset-regular',
                    title: 'تماس با پشتیبانی',
                    type: ESlidenavMenu.SUPPORT
                },
            ];
        }
        else {
            const guidItem: ISidenavMenuItem = {
                count: 0,
                icon: 'question-circle-regular',
                title: 'راهنمای بهخوان',
                type: ESlidenavMenu.GUID,
                link: this._linkGenerator(ESlidenavMenu.GUID, userId)
            };
            let extraItems: ISidenavMenuItem[] = [];
            if (userName) {
                extraItems = [
                    {
                        count: 0,
                        icon: 'alert-regular',
                        title: 'اعلانات',
                        type: ESlidenavMenu.NOTIFICATION,
                        link: this._linkGenerator(ESlidenavMenu.NOTIFICATION)

                    },
                    {
                        count: 0,
                        icon: 'library-regular',
                        title: 'کتابخانه',
                        type: ESlidenavMenu.LIBRARY,
                        query: {
                            'shelfOwner': this.userStateService.userDataSnapshot?.firstName,
                        },
                        link: this._linkGenerator(ESlidenavMenu.LIBRARY, userId)
                    },
                    {
                        count: 0,
                        icon: 'mail-regular',
                        title: 'پیام‌ها',
                        type: ESlidenavMenu.MESSAGES,
                        link: this._linkGenerator(ESlidenavMenu.MESSAGES, userName)
                    },
                    {
                        count: 0,
                        icon: 'bookmark-regular',
                        title: 'نشان‌شده‌ها',
                        type: ESlidenavMenu.BOOKMARKS,
                        link: this._linkGenerator(ESlidenavMenu.BOOKMARKS, userName)
                    },
                    {
                        count: 0,
                        icon: 'settings-regular',
                        title: 'تنظیمات',
                        type: ESlidenavMenu.SETTING,
                        link: this._linkGenerator(ESlidenavMenu.SETTING, userId)
                    },
                    guidItem,
                    {
                        count: 0,
                        icon: 'headset-regular',
                        title: 'تماس با پشتیبانی',
                        type: ESlidenavMenu.SUPPORT,
                        link: this._linkGenerator(ESlidenavMenu.SUPPORT, userId)

                    },
                    {
                        count: 0,
                        icon: 'line-horizontal-3-regular',
                        title: 'بیشتر',
                        type: ESlidenavMenu.More,
                        children: [
                            {
                                count: 0,
                                icon: 'people-team-regular',
                                title: 'باشگاه‌های من',
                                type: ESlidenavMenu.CLUBS,
                                link: this._linkGenerator(ESlidenavMenu.CLUBS, userId)
                            },
                            {
                                count: 0,
                                icon: 'ribbon-star-regular',
                                title: 'چالش‌ها',
                                type: ESlidenavMenu.CHALLENGES,
                                link: this._linkGenerator(ESlidenavMenu.CHALLENGES, userName)
                            },
                            {
                                count: 0,
                                icon: 'book-add-regular',
                                title: 'کتابداری',
                                type: ESlidenavMenu.ADDED_BOOKS,
                                link: this._linkGenerator(ESlidenavMenu.ADDED_BOOKS, userName)
                            },
                        ],
                        link: this._linkGenerator(ESlidenavMenu.More, userId)
                    },

                ]
            }

            const menu: ISidenavMenuItem[] = [
                {
                    count: 0,
                    icon: 'home-regular',
                    title: 'صفحۀ اصلی',
                    type: ESlidenavMenu.HOME,
                    link: this._linkGenerator(ESlidenavMenu.HOME, userName)
                },
                {
                    count: 0,
                    icon: 'explore',
                    title: 'گشت‌وگذار',
                    type: ESlidenavMenu.EXPLORE,
                    link: this._linkGenerator(ESlidenavMenu.EXPLORE, userName)
                }
            ];
            return userName ? [...menu, ...extraItems] : [...menu, guidItem];
        }
    }
    private _linkGenerator(type: ESlidenavMenu, userId?: string): string {
        switch (type) {
            case ESlidenavMenu.LIBRARY:
                return htmlUrls.library + userId;
            case ESlidenavMenu.ADDED_BOOKS:
                return htmlUrls.added_books;
            case ESlidenavMenu.CLUBS:
                return htmlUrls.list_club + userId;
            case ESlidenavMenu.NOTIFICATION:
                return htmlUrls.notifications
            case ESlidenavMenu.CHALLENGES:
                return htmlUrls.challenges;
            case ESlidenavMenu.BOOKMARKS:
                return htmlUrls.bookmark;
            case ESlidenavMenu.MESSAGES:
                return htmlUrls.message;
            case ESlidenavMenu.HOME:
                return htmlUrls.feed;
            case ESlidenavMenu.EXPLORE:
                return htmlUrls.explore;
            case ESlidenavMenu.REVIEWS:
                return htmlUrls.reviews;
            case ESlidenavMenu.BOOK_LISTS:
                return htmlUrls.bookLists
            case ESlidenavMenu.POSTS:
                return htmlUrls.posts
            case ESlidenavMenu.SETTING:
                return htmlUrls.setting_profile;
            case ESlidenavMenu.SUPPORT:
                return '';
            case ESlidenavMenu.GUID:
                return htmlUrls.behkhaan_guid;
            case ESlidenavMenu.More:
                return '';
            default:
                return '';
        }
    }
}

